import {
  Select,
  InputLabel,
  Tooltip,
  Icon,
  MenuItem,
  Chip,
  styled,
} from '@nextiva/next-ui-components';

interface StyledChip {
  enableWarningColor: boolean;
}

export const StyledContainer = styled('div')`
  width: 100%;
  margin-bottom: 16px;
`;
export const StyledLabelContainer = styled('div')`
  display: flex;
  margin-bottom: 4px;
`;
export const StyledLabel = styled(InputLabel)`
  color: ${({ theme }) => theme.palette.blueGrey.A400};
`;
export const StyledHelpIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
  margin: -4px 0px 0px 8px;
  transform: scale(0.923);
`;
export const StyledSelect = styled(Select)`
  height: 40px !important;

  .MuiSelect-select:focus {
    background-color: transparent !important;
  }
  .MuiInputBase-input {
    height: 32px !important;
    padding: 4px 3px !important;
  }
`;
export const StyledTooltip = styled(Tooltip)`
  .MuiTooltip-tooltip {
    background-color: rgba(97, 97, 97, 0.9);
    font-weight: 500;
    font-size: 14px;
    max-width: 300px;
    color: ${({ theme }) => theme.palette.primary.contrastText};
  }
`;
export const StyledChipsContainer = styled('div')`
  width: 94%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const StyledChip = styled(Chip)<StyledChip>`
  margin-left: 4px;
  .removeSolid {
    color: ${({ theme, enableWarningColor }) =>
      enableWarningColor
        ? theme.palette.warning.contrastText
        : theme.palette.blueGrey.A400};
  }
`;
export const StyledMenuItem = styled(MenuItem)`
  line-height: 1.1875rem;
  color: #232649;
`;
